"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandSubChildren = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const ToolbarMenuMore_1 = require("./ToolbarMenuMore");
const ToolbarMenuItem_1 = require("./ToolbarMenuItem");
const ExpandSubChildren = ({ item, parent, disabled }) => {
    const nodes = [];
    const children = parent.preview ?? item.preview ?? item.children;
    const length = children?.length ?? 0;
    const max = Math.min(item.expand ?? 4, 4);
    for (let i = 0; i < length; i++) {
        if (i >= max)
            break;
        const child = children[i];
        if (child.icon)
            nodes.push(React.createElement(ToolbarMenuItem_1.ToolbarMenuItem, { key: child.id || child.name || i, item: child, disabled: disabled }));
    }
    nodes.push(React.createElement(ToolbarMenuMore_1.ToolbarMenuMore, { key: '_more', item: parent, disabled: disabled }));
    return React.createElement(React.Fragment, null, nodes);
};
exports.ExpandSubChildren = ExpandSubChildren;
